const YOUTUBE_PANEL_ID = "noah-youtube-panel";
const YOUTUBE_TOGGLE_ID = "noah-youtube-toggle";
const YOUTUBE_IFRAME_ID = "noah-youtube-iframe";

const STORAGE_URL = "noahYoutubeUrl";
const STORAGE_LOOP = "noahYoutubeLoop";
const STORAGE_WIDTH = "noahYoutubeWidth";
const STORAGE_PLAYER_HEIGHT = "noahYoutubePlayerHeight";


function isYoutubeMobileLayout(): boolean {
    return window.matchMedia("(max-width: 520px)").matches;
}

function clampYoutubeSize(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max);
}

function getSavedYoutubeWidth(): number {
    const saved = Number(localStorage.getItem(STORAGE_WIDTH));
    return Number.isFinite(saved) && saved > 0 ? saved : 320;
}

function getSavedYoutubePlayerHeight(): number {
    const saved = Number(localStorage.getItem(STORAGE_PLAYER_HEIGHT));
    return Number.isFinite(saved) && saved > 0 ? saved : 200;
}

function applyYoutubePanelSize(): void {
    const panel = document.getElementById(YOUTUBE_PANEL_ID) as HTMLDivElement | null;
    const iframe = document.getElementById(YOUTUBE_IFRAME_ID) as HTMLIFrameElement | null;

    if (!panel || !iframe) {
        return;
    }

    const maxWidth = Math.max(1, window.innerWidth - 24);
    const maxHeight = Math.max(1, window.innerHeight - 180);

            const isMobile = isYoutubeMobileLayout();

    const width = clampYoutubeSize(getSavedYoutubeWidth(), 1, maxWidth);
    const playerHeight = clampYoutubeSize(getSavedYoutubePlayerHeight(), 1, maxHeight);

    panel.style.width = `${width}px`;
    iframe.style.height = `${playerHeight}px`;
}

function initYoutubeResizeHandle(): void {
    const panel = document.getElementById(YOUTUBE_PANEL_ID) as HTMLDivElement | null;
    const iframe = document.getElementById(YOUTUBE_IFRAME_ID) as HTMLIFrameElement | null;
    const handle = document.getElementById("noah-youtube-resize-handle") as HTMLDivElement | null;

    if (!panel || !iframe || !handle) {
        return;
    }

    handle.style.touchAction = "none";

    handle.addEventListener("pointerdown", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const startX = event.clientX;
        const startY = event.clientY;
        const startWidth = panel.getBoundingClientRect().width;
        const startHeight = iframe.getBoundingClientRect().height;
        const isMobile = isYoutubeMobileLayout();

        try {
            handle.setPointerCapture(event.pointerId);
        }
        catch {
            // 一部ブラウザでは失敗することがあるが、resize自体は続行する
        }

        document.body.classList.add("noah-youtube-resizing");

        const onPointerMove = (moveEvent: PointerEvent) => {
            moveEvent.preventDefault();
            moveEvent.stopPropagation();

            const dx = moveEvent.clientX - startX;
            const dy = moveEvent.clientY - startY;

            const maxWidth = Math.max(1, window.innerWidth - (isMobile ? 16 : 24));
            const maxHeight = Math.max(1, window.innerHeight - 180);

            // PC: 右下固定・左上ハンドルなので、左上へ動かすほど大きくする
            // スマホ: 左上固定・右下ハンドルなので、右下へ動かすほど大きくする
            const nextWidth = clampYoutubeSize(isMobile ? startWidth + dx : startWidth - dx, 1, maxWidth);
            const nextHeight = clampYoutubeSize(isMobile ? startHeight + dy : startHeight - dy, 1, maxHeight);

            panel.style.width = `${nextWidth}px`;
            iframe.style.height = `${nextHeight}px`;

            localStorage.setItem(STORAGE_WIDTH, String(Math.round(nextWidth)));
            localStorage.setItem(STORAGE_PLAYER_HEIGHT, String(Math.round(nextHeight)));
        };

        const onPointerUp = () => {
            document.body.classList.remove("noah-youtube-resizing");
            window.removeEventListener("pointermove", onPointerMove);
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
        };

        window.addEventListener("pointermove", onPointerMove, { passive: false });
        window.addEventListener("pointerup", onPointerUp);
        window.addEventListener("pointercancel", onPointerUp);
    }, { passive: false });
}

function extractYoutubeVideoId(input: string): string | null {
    const value = input.trim();

    if (!value) {
        return null;
    }

    // Raw video id
    if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
        return value;
    }

    try {
        const url = new URL(value);

        const hostname = url.hostname.replace(/^www\./, "");

        if (hostname === "youtube.com" || hostname === "m.youtube.com") {
            if (url.pathname === "/watch") {
                return url.searchParams.get("v");
            }

            const shortsMatch = url.pathname.match(/^\/shorts\/([a-zA-Z0-9_-]{11})/);
            if (shortsMatch) {
                return shortsMatch[1];
            }

            const embedMatch = url.pathname.match(/^\/embed\/([a-zA-Z0-9_-]{11})/);
            if (embedMatch) {
                return embedMatch[1];
            }
        }

        if (hostname === "youtu.be") {
            const id = url.pathname.replace("/", "").split("/")[0];
            return /^[a-zA-Z0-9_-]{11}$/.test(id) ? id : null;
        }
    }
    catch {
        return null;
    }

    return null;
}

function buildYoutubeEmbedUrl(videoId: string, loop: boolean): string {
    const params = new URLSearchParams({
        rel: "0",
        playsinline: "1",
    });

    if (loop) {
        params.set("loop", "1");
        params.set("playlist", videoId);
    }

    return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
}

function findShortcutContainer(): HTMLElement | null {
    const bgmButton = document.getElementById("noah-bgm-toggle");
    if (bgmButton?.parentElement) {
        return bgmButton.parentElement;
    }

    const labels = ["#ｲﾍﾞﾝﾄ", "#event", "#ﾘｽﾄ", "#list"];

    for (const label of labels) {
        const buttons = Array.from(document.querySelectorAll("button, input[type='button']")) as HTMLElement[];

        const found = buttons.find((button) => {
            if (button instanceof HTMLInputElement) {
                return button.value === label;
            }

            return button.textContent?.trim() === label;
        });

        if (found?.parentElement) {
            return found.parentElement;
        }
    }

    return null;
}

function stopYoutube(): void {
    const iframe = document.getElementById(YOUTUBE_IFRAME_ID) as HTMLIFrameElement | null;
    if (iframe) {
        iframe.src = "";
    }
}

function playYoutube(): void {
    const input = document.getElementById("noah-youtube-url") as HTMLInputElement | null;
    const loopInput = document.getElementById("noah-youtube-loop") as HTMLInputElement | null;
    const message = document.getElementById("noah-youtube-message");
    const iframe = document.getElementById(YOUTUBE_IFRAME_ID) as HTMLIFrameElement | null;

    if (!input || !loopInput || !iframe) {
        return;
    }

    const url = input.value.trim();
    const videoId = extractYoutubeVideoId(url);

    if (!videoId) {
        if (message) {
            message.textContent = "YouTubeのURLまたは動画IDを入力してください。";
        }
        return;
    }

    localStorage.setItem(STORAGE_URL, url);
    localStorage.setItem(STORAGE_LOOP, loopInput.checked ? "true" : "false");

    iframe.src = buildYoutubeEmbedUrl(videoId, loopInput.checked);

    if (message) {
        message.textContent = "";
    }
}

function setPanelVisible(visible: boolean): void {
    const panel = document.getElementById(YOUTUBE_PANEL_ID);
    const toggle = document.getElementById(YOUTUBE_TOGGLE_ID);

    if (!panel) {
        return;
    }

    panel.hidden = !visible;
    if (toggle) {
        toggle.classList.toggle("active", visible);
    }

    if (!visible) {
//        stopYoutube();
    }
}


function hideYoutubePanelWhenLoggedOut(): void {
    const panel = document.getElementById(YOUTUBE_PANEL_ID);

    if (!panel || panel.hidden) {
        return;
    }

    // ログイン後UIのBGMボタンが消えていたら、ログアウト/ログイン画面とみなして閉じる
    if (!document.getElementById("noah-bgm-toggle")) {
        setPanelVisible(false);
    }
}

function togglePanel(): void {
    const panel = document.getElementById(YOUTUBE_PANEL_ID);

    if (!panel) {
        return;
    }

    setPanelVisible(panel.hidden);
}

function createYoutubeButton(): void {
    if (document.getElementById(YOUTUBE_TOGGLE_ID)) {
        return;
    }

    const container = findShortcutContainer();

    if (!container) {
        return;
    }

    const button = document.createElement("button");
    button.id = YOUTUBE_TOGGLE_ID;
    button.type = "button";
    button.textContent = "▶";
    button.title = "YouTube Player";
    button.className = "noah-youtube-toggle";
    button.addEventListener("click", togglePanel);

    const bgmButton = document.getElementById("noah-bgm-toggle");

    if (bgmButton?.parentElement === container) {
        bgmButton.insertAdjacentElement("afterend", button);
    }
    else {
        container.appendChild(button);
    }
}

function createYoutubePanel(): void {
    if (document.getElementById(YOUTUBE_PANEL_ID)) {
        return;
    }

    const panel = document.createElement("div");
    panel.id = YOUTUBE_PANEL_ID;
    panel.className = "noah-youtube-panel";
    panel.hidden = true;

    const savedUrl = localStorage.getItem(STORAGE_URL) || "";
    const savedLoop = localStorage.getItem(STORAGE_LOOP);
    const loopChecked = savedLoop === null ? true : savedLoop === "true";

    panel.innerHTML = `
        <div id="noah-youtube-resize-handle" title="ドラッグで拡大縮小"></div>
        <div class="noah-youtube-header">
            <span>YouTube</span>
            <button type="button" id="noah-youtube-close" title="閉じる">×</button>
        </div>

        <div class="noah-youtube-form">
            <input
                type="text"
                id="noah-youtube-url"
                placeholder="YouTube URL"
                value="${savedUrl.replace(/"/g, "&quot;")}"
                autocomplete="off"
                spellcheck="false"
            >

            <div class="noah-youtube-controls">
                <button type="button" id="noah-youtube-play">再生</button>
                <button type="button" id="noah-youtube-stop">停止</button>
                <label>
                    <input type="checkbox" id="noah-youtube-loop" ${loopChecked ? "checked" : ""}>
                    リピート
                </label>
            </div>

            <div id="noah-youtube-message" class="noah-youtube-message"></div>
        </div>

        <iframe
            id="${YOUTUBE_IFRAME_ID}"
            class="noah-youtube-iframe"
            title="YouTube player"
            src=""
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
        ></iframe>
    `;

    document.body.appendChild(panel);

    document.getElementById("noah-youtube-close")?.addEventListener("click", () => setPanelVisible(false));
    document.getElementById("noah-youtube-play")?.addEventListener("click", playYoutube);
    document.getElementById("noah-youtube-stop")?.addEventListener("click", stopYoutube);

    document.getElementById("noah-youtube-url")?.addEventListener("keydown", (event) => {
        if (event instanceof KeyboardEvent && event.key === "Enter") {
            playYoutube();
        }
    });

    document.getElementById("noah-youtube-loop")?.addEventListener("change", () => {
        const loopInput = document.getElementById("noah-youtube-loop") as HTMLInputElement | null;
        if (loopInput) {
            localStorage.setItem(STORAGE_LOOP, loopInput.checked ? "true" : "false");
        }
    });

    applyYoutubePanelSize();
    initYoutubeResizeHandle();
}

function injectYoutubeStyle(): void {
    if (document.getElementById("noah-youtube-style")) {
        return;
    }

    const style = document.createElement("style");
    style.id = "noah-youtube-style";
    style.textContent = `
.noah-youtube-toggle {
    margin-left: 4px;
}

.noah-youtube-toggle.active {
    font-weight: bold;
}

.noah-youtube-panel {
    position: fixed;
    overflow: visible;
    right: 12px;
    bottom: 12px;
    width: 320px;
    max-width: calc(100vw - 24px);
    background: rgba(245, 245, 245, 0.96);
    border: 1px solid #777;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
    z-index: 10000;
    font-size: 12px;
    color: #222;
}

#noah-youtube-resize-handle {
    position: absolute;
    left: -6px;
    top: -6px;
    width: 16px;
    height: 16px;
    z-index: 10001;
    cursor: nwse-resize;
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
}

#noah-youtube-resize-handle::before {
    content: "";
    position: absolute;
    left: 5px;
    top: 5px;
    width: 8px;
    height: 8px;
    background: #555;
    border: 1px solid #fff;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

.noah-youtube-resizing {
    user-select: none;
}

.noah-youtube-resizing iframe {
    pointer-events: none;
}

.noah-youtube-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 4px 6px;
    background: #333;
    color: #fff;
    font-weight: bold;
}

#noah-youtube-close {
    min-width: 24px;
    min-height: 22px;
}

.noah-youtube-form {
    padding: 6px;
}

#noah-youtube-url {
    box-sizing: border-box;
    width: 100%;
    margin-bottom: 6px;
}

.noah-youtube-controls {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.noah-youtube-message {
    min-height: 16px;
    color: #b00020;
    margin-top: 4px;
}

.noah-youtube-iframe {
    display: block;
    width: 100%;
    max-width: 100%;
    height: 200px;
    border: 0;
    background: #000;
}

@media (max-width: 520px) {
    .noah-youtube-panel {
        left: 8px;
        top: 8px;
        right: auto;
        bottom: auto;
        max-width: calc(100vw - 16px);
    }

    .noah-youtube-iframe {
        width: 100%;
        height: 200px;
    }

    #noah-youtube-resize-handle {
        left: auto;
        top: auto;
        right: -12px;
        bottom: -12px;
        width: 32px;
        height: 32px;
        cursor: nwse-resize;
    }

    #noah-youtube-resize-handle::before {
        left: 9px;
        top: 9px;
        width: 12px;
        height: 12px;
    }
}
`;
    document.head.appendChild(style);
}

export function initYoutubePlayer(): void {
    injectYoutubeStyle();

    const setup = () => {
        createYoutubePanel();
        createYoutubeButton();
    };

    setup();

    // ログイン後にツールバーやBGMボタンが後から生成されるため、
    // 見つかるまでしばらく再試行する。
    const retryTimer = window.setInterval(() => {
        setup();

        if (document.getElementById(YOUTUBE_TOGGLE_ID)) {
            window.clearInterval(retryTimer);
        }
    }, 500);

    window.setTimeout(() => {
        window.clearInterval(retryTimer);
    }, 30000);

    // DOM変化も監視して、ログイン後のボタン欄生成に追従する。
    const observer = new MutationObserver(() => {
        setup();
        hideYoutubePanelWhenLoggedOut();

        if (document.getElementById(YOUTUBE_TOGGLE_ID)) {
            observer.disconnect();
            window.clearInterval(retryTimer);
        }
    });

    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
    }

    window.addEventListener("beforeunload", () => {
//        stopYoutube();
    });
}
